import ReactGA from 'react-ga4'

export const openAssistOptions = async () => {
  ReactGA.event({
    category: 'AI Assistant',
    action: 'ai_assist_button_on_create_post',
    label: 'Open AI assist options popup',
  })
}

export const openModal = async (option: string) => {
  ReactGA.event({
    category: 'AI Assistant',
    action: `ai_action_${option}`,
    label: `${option} content`,
  })
}

export const closeModal = async () => {
  ReactGA.event({
    category: 'AI Assistant',
    action: 'ai_assistant_close',
    label: 'Close AI Assistant modal',
  })
}

export const insertContent = async () => {
  ReactGA.event({
    category: 'AI Assistant',
    action: 'ai_assistant_insert',
    label: 'Insert the AI response',
  })
}

export const getAnotherResponse = async () => {
  ReactGA.event({
    category: 'AI Assistant',
    action: 'ai_assistant_try_again',
    label: 'Get another response from AI',
  })
}

export const openLogs = async () => {
  ReactGA.event({
    category: 'AI Assistant',
    action: 'ai_assist_log',
    label: 'Open AI Assistant logs',
  })
}

export const actionPill = async (action: string) => {
  ReactGA.event({
    category: 'AI Assistant',
    action: `ai_assistant_${action}`,
    label: `AI Assistant action - ${action}`,
  })
}
